import React, { useState } from "react";
import HospitalListCard from "./HospitalListCard";

const HospitalList = ({
  hospitalsList,
  sortingLabel,
  toggleState,
}) => {
  const [bookmarkedItemsSet, setBookmarkedItemsSet] = useState(new Set());

  const handleBookmarkedItems = (e, item) => {
    e.stopPropagation();
    const bookmarksSet = new Set(bookmarkedItemsSet);
    if (bookmarksSet.has(item)) {
      bookmarksSet.delete(item);
    } else {
      bookmarksSet.add(item);
    }

    setBookmarkedItemsSet(bookmarksSet);
  };

  return (
    <>
      {hospitalsList?.map((ele, i) => (
        <HospitalListCard
          data={ele}
          key={i}
          bookmarkedItemsSet={bookmarkedItemsSet}
          handleBookmarkedItems={handleBookmarkedItems}
          sortingLabel={sortingLabel}
          toggleState={toggleState}
        />
      ))}
    </>
  );
};

export default HospitalList;
